import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router";

const PageLoader = PageComponent => () => (
  <React.Suspense fallback="">
    <PageComponent />
  </React.Suspense>
);

/**
 * @param {Object} props
 * @returns {Route}
 */
export default class LazyRoute extends React.PureComponent {
  /**
   * @returns {ReactElement}
   */
  render() {
    const { path, component } = this.props;

    return (
      <Route
        path={path}
        render={PageLoader(component)}
      />
    );
  }
}

LazyRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
};
